import {useEffect,useState} from 'react';
import api from '@/lib/axios';
import {procurementContextKey} from '@/lib/procurementAssistantRequests';
import {OPERATIONAL_CONTEXT_EVENT,procurementExpectedUser} from '@/lib/procurementOperationalContext';

export function useProcurementOperationalContext(user, enabled) {
  const key = procurementContextKey(user);
  const platform = user?.is_platform_admin === true;
  const [revision,setRevision] = useState(0),[snapshot,setSnapshot] = useState(null);
  useEffect(()=>{
    if (!enabled || !platform) return;
    const refresh = ()=>setRevision(value=>value+1);
    const visible = ()=>{if(document.visibilityState==='visible')refresh();};
    window.addEventListener(OPERATIONAL_CONTEXT_EVENT,refresh);
    window.addEventListener('focus',refresh);
    document.addEventListener('visibilitychange',visible);
    return ()=>{window.removeEventListener(OPERATIONAL_CONTEXT_EVENT,refresh);window.removeEventListener('focus',refresh);document.removeEventListener('visibilitychange',visible);};
  },[enabled,platform]);
  useEffect(()=>{
    if (!enabled || !platform || !key) return;
    const controller = new AbortController();
    (async()=>{
      try {
        const {data} = await api.get('/admin/context',{signal:controller.signal});
        const expected = procurementExpectedUser(user,data);
        if(!controller.signal.aborted)setSnapshot({key,revision,expected});
      } catch {
        if(!controller.signal.aborted)setSnapshot({key,revision,error:'The selected company and unit could not be confirmed. Refresh the page or select the unit again.'});
      }
    })();
    return ()=>controller.abort();
    // The complete identity/permission key controls stale-response rejection.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[enabled,platform,key,revision]);
  if (!platform) return {expected:user};
  if(!snapshot || snapshot.key!==key)return {loading:true};
  // Retain the mounted form during same-account revalidation. Consumers hide it
  // until the server confirms the selection, then remount only if scope changed.
  return {...snapshot,refreshing:snapshot.revision!==revision};
}
